var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":_vm.label,"disabled":_vm.disabled,"attr":_vm.attr,"error-messages":_vm.errorMessages,"items":_vm.items,"multiple":""},on:{"change":_vm.changeSelect},model:{value:(_vm.ids),callback:function ($$v) {_vm.ids=$$v},expression:"ids"}})
}
var staticRenderFns = []

export { render, staticRenderFns }